import _ from 'lodash';
import moment from "moment";

const getDotColor = (color, event) => {
  if (color != null && color.startsWith("$.")) {
    const colorField = color.replace("$.", "");
    const colorFieldValue = _.get(event, colorField, "");

    if (!colorFieldValue) return '#ccc'
    return '#ccc'
  }
  return color;
}

const tranformEventMap = (date, dataEvents, templates, owners) => {
  dataEvents = dataEvents.flatMap((e) => {
    let d = moment(e.ts)
      .format('dddd M/D/YYYY')
      .toUpperCase();
    if (d === date) return [e];
    else {
      date = d;
      return [{ signal: 'DATE', date: d }, e];
    }
  });

  if (!templates || !templates.data || !templates.data.length === 0) return;
  const dataTemplates = templates.data;
  let dataMap = new Map();
  for (const e of dataEvents) {
    let template = dataTemplates.find(f => owners?.some(o => f.owners.includes(o))) || dataTemplates.find(f => f.action === e.signal && f.type === e.type);
    template = template ? template : dataTemplates.find(f => f.category === 'DEFAULT' && f.type === 'DEFAULT' && f.action === 'default');
    if (template && !template.hidden && e.signal !== 'DATE') {
      dataMap.set(e.id || `${e.signal}-${e.ts}`, {
        origin: e,
        converted: {},
        template: template,
      })
    }
    if (e.signal === 'DATE') {
      template = dataTemplates.find(f => f.category === 'DATE' && f.type === 'DATE' && f.action === 'date');
      dataMap.set(e.date, {
        origin: e,
        converted: {
          date: e.date,
        },
        template: template,
      })
    }
  }
  return dataMap;
}

export {
  getDotColor,
  tranformEventMap,
}
